
    const original = "<svg\r\n   viewBox=\"0 0 20 20\"\r\n   version=\"1.1\"\r\n   id=\"svg1\"\r\n   width=\"20\"\r\n   height=\"20\"\r\n   xmlns=\"http://www.w3.org/2000/svg\"\r\n   xmlns:svg=\"http://www.w3.org/2000/svg\">\r\n  <defs\r\n     id=\"defs1\" />\r\n  <path\r\n     d=\"M 2.5000001,16.477273 H 17.5 L 9.9999999,3.5227274 Z M 10.681818,14.431819 H 9.3181818 v -1.363637 h 1.3636362 z m 0,-2.727273 H 9.3181818 V 8.9772728 h 1.3636362 z\"\r\n     id=\"path2-2\"\r\n     style=\"fill:#855cd6;fill-opacity:1;stroke-width:1\" />\r\n</svg>\r\n";

    const getSRC = () => {
        const recolored = typeof Recolor === 'object' ? (
            original.replace(/#855cd6/gi, Recolor.primary)
        ) : original;
        return 'data:image/svg+xml;,' + encodeURIComponent(recolored);
    };

    export default getSRC;
